import request from '@/utils/request';

import { getCookie,createBase64 } from '@/utils/util.js';

let token = "";
let companyKey = "";
let base64 = createBase64();
const Qs = require('qs');


export const sendPostRqe = (params,url) => {
  return request({
      url: url,
      transformRequest: [function(data) {      //在请求之前对data传参进行格式转换
        data = Qs.stringify(data);
        return data
      }],
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/x-www-form-urlencoded'
      },
  });
};


export const sendPostRqeByJSON = (params,url) => {
  return request({
      url: url,
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/json'
      },
  });
};

export const sendPostRqeByFormData = (params,url) => {
  return request({
      url: url,
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'multipart/form-data; boundary=----WebKitFormBoundarynl6gT1BKdPWIejNq'
      },
  });
};

export const getByUrl = (url) => {
  return request({
     url: url,
     method: 'get',
     headers:{
     }
 });
};

export const getByParam = (url,query) => {
  return request({
     url: url,
     params: query,
     method: 'get',
     headers:{
     
    }
 });
};

export const login = params => {
  let data={data: base64.encode(JSON.stringify(params))};
  return request({
      url: '/home/login/username',
      transformRequest: [function(data) {      //在请求之前对data传参进行格式转换
        data = Qs.stringify(data);
        return data
      }],
      method: 'post',
      data: data,
      headers:{
        'Content-Type': 'application/x-www-form-urlencoded',
      },
  });
};

//获取验证码
export const getCaptcha = params => {
  let data={data: base64.encode(JSON.stringify(params))};
   return request({
      url: '/home/sendSms',
      transformRequest: [function(data) {      //在请求之前对data传参进行格式转换
        data = Qs.stringify(data);
        return data
      }],
      method: 'post',
      data: data,
      headers:{
        'Content-Type': 'application/x-www-form-urlencoded',
         token: getCookie("token") || token,
         companyKey:getCookie("companyKey") || companyKey
      }
  });
};

//短信验证码登录
export const smslogin = params => {
  let data={data: base64.encode(JSON.stringify(params))};
  // companyKey = getCookie('companyKey')? getCookie('companyKey') : 'yg_zj';
  // setCookie("companyKey", companyKey, 1);
  return request({
      url: '/home/login/sms',
      transformRequest: [function(data) {      //在请求之前对data传参进行格式转换
        data = Qs.stringify(data);
        return data
      }],
      method: 'post',
      data: data,
      headers:{
        'Content-Type': 'application/x-www-form-urlencoded',
         companyKey:companyKey
      },
  });
};
